import { unwrap } from "@majourneys/api-client";
import { api } from "../../../lib/api";
import type { ReelFilters } from "../constants/query-keys";

export const reelsApi = {
  list: async (filters?: ReelFilters) =>
    unwrap(await api.reels.get({ query: filters })),
};
